/**
 * Vue Router may expose `route.path` percent-encoded on SSR and decoded in the browser
 * for non-ASCII segments (e.g. `/kr/%EC%98%81%ED%99%94/...` vs `/kr/영화/...`).
 *
 * GraphQL `urlV2(fullPath:)` cache keys must use the same string on both sides.
 * Normalization for Apollo queries is handled globally by `withNormalizedFullPath()`
 * in `src/graphql/utils/links.ts`. Use this helper for non-GraphQL comparisons
 * (e.g. routing store sync, matching against API `content.fullPath`).
 */
export function decodeRoutePath(path: string): string {
	try {
		return decodeURI(path);
	} catch {
		return path;
	}
}
